import React from "react";
import ReactDOM from "react-dom";
import PopupDetailsWidget from "./PopupDetailsWidget";

export const injectPopupDetailsIntoContent = (view,node,layerIds,pageConfig) => {
    ReactDOM.render(
      <PopupDetailsWidget view={view} layerIds={layerIds} pageConfig={pageConfig}></PopupDetailsWidget>,
      node
    ) as unknown as HTMLElement;
  };